module.exports = __webpack_public_path__ + "static/media/Bubble-image-11.1092e2e2.png";